<div class="link-card" (click)="openLinkInNewTab()">
  <div class="link-icon font-color-black">
    <i class="fa-regular fa-link"></i>
  </div>
  <div class="link-title">{{ link.title }}</div>

  <button
    type="button"
    class="action-button circle-xsmall border-none"
    [disabled]="(loadingLinkId$ | async) === link.id"
    [pTooltip]="(loadingLinkId$ | async) === link.id ? 'Lädt...' : 'Aktionen'"
    [tooltipPosition]="'top'"
    (click)="linkMenu.toggle($event); $event.stopPropagation()">
    @if ((loadingLinkId$ | async) === link.id) {
      <i class="fa-regular fa-spinner fa-spin circle-icon"></i>
    } @else {
      <i class="fa-regular fa-ellipsis-vertical circle-icon"></i>
    }
  </button>
</div>

<p-menu #linkMenu [model]="linkMenuItems" [popup]="true" appendTo="body">
  <ng-template pTemplate="item" let-item>
    <a pRipple class="flex align-items-center p-menu-item-link icon-24">
      <i [class]="item.icon"></i>
      <span class="ml-2">{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>
